import React, { useContext } from "react";
import { DesktopGrid } from "~/assets/js/components/Layout/DesktopGrid";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import CheckoutSummary from "~/assets/js/components/CheckoutSummary";
import Headline from "~/assets/js/components/Typography/Headline";
import StickyFooter from "~/assets/js/components/StickyFooter";
import i18n from "~/assets/js/Helpers/i18n";
import PaymentSelectComponent from "./PaymentSelect";
import { ACTIONS, CheckoutContext, PAGES } from "../../CheckoutProvider";
import Notification from "~/assets/js/components/Notification";
import { DangerIcon } from "~/assets/js/components/Icons";
import i18next from "i18next";
import { useCartContext } from "~/assets/js/global/cartContext";
import ReusableBowlsPaymentBanner from "../../../../components/ReusableBowls/ReusableBowlsPaymentBanner";
import { hasReusableBowls } from "~/assets/js/Helpers/reusable-bowls-utils";
import useGroupOrder from "~/assets/js/global/useGroupOrder";

const PaymentSelect = () => {
    const { isDesktop } = useViewport();
    const { cart, requiresPayment } = useCartContext();
    const { isGroupOrder } = useGroupOrder();
    const { dispatch } = useContext(CheckoutContext);
    const { paymentErrorReason } = reactConfig;
    const isReusableBowl = hasReusableBowls(cart?.items);

    const handleClick = () => {
        // Clear error message loop
        reactConfig.paymentErrorReason = null;
        const nextPage = !isGroupOrder
            ? PAGES.TIME_SLOT_SELECT
            : PAGES.ORDER_OVERVIEW;

        dispatch({
            type: ACTIONS.CHANGE_PAGE,
            payload: nextPage,
        });
    };

    const paymentOptionMustBeSelected =
        requiresPayment &&
        (cart.payment?.method === undefined || cart.payment?.method === null);

    return (
        <>
            <DesktopGrid
                leftSide={
                    <>
                        <Headline size={5} resizable>
                            {i18n.t("paymentSelect.heading")}
                        </Headline>
                        {paymentErrorReason && (
                            <Notification
                                style={{
                                    margin: "20px 0",
                                    display: "flex",
                                }}
                                type="danger"
                                icon={<DangerIcon />}
                            >
                                <Headline size={6}>
                                    {i18next.t(
                                        "paymentSelect.paymentError.headline"
                                    )}
                                </Headline>
                                {i18next.t(
                                    "paymentSelect.paymentError.content"
                                )}
                            </Notification>
                        )}
                        {isReusableBowl && <ReusableBowlsPaymentBanner />}
                        <PaymentSelectComponent />
                    </>
                }
                rightSide={
                    isDesktop && (
                        <CheckoutSummary
                            handleDesktopMoveForward={handleClick}
                            desktopForwardLabel={i18n.t("cart.continue")}
                            forwardButtonDisabled={paymentOptionMustBeSelected}
                        />
                    )
                }
            />

            <StickyFooter
                CTA="cart.continue"
                totals={cart?.value_gross}
                onClick={handleClick}
                disabled={
                    requiresPayment &&
                    (cart.payment?.method === undefined ||
                        cart.payment?.method === null)
                }
            />
        </>
    );
};

export default PaymentSelect;
